import * as React from "react";
import Edit from "components/icons/pencil";

export type Sort = "asc" | "desc" | null | undefined;
type onClickMenu = (target: HTMLElement) => void;

type Props = {
    displayName: string;
    canEdit: boolean;
    isFilterActive: boolean;
    sorting: Sort;
    onClickMenu: onClickMenu;
    onEditClickHandler: () => void;
};
export const LabelIconsWrapper = ({
    displayName,
    canEdit,
    isFilterActive,
    sorting,
    onClickMenu,
    onEditClickHandler,
}: Props) => {
    return (
        <>
            <div style={{ display: "flex" }}>
                {displayName}
                {canEdit && <EditButton onClick={onEditClickHandler} />}
                {isFilterActive && <Filter />}
                {<Sorting sorting={sorting} />}
            </div>
            <Menu onClick={onClickMenu} />
        </>
    );
};

const Sorting = ({ sorting }: { sorting: Sort }) =>
    sorting ? (
        <span className={`ag-header-icon ag-header-label-icon ag-sort-${sorting}ending-icon`} aria-hidden="true">
            <span className={`ag-icon ag-icon-${sorting}`} unselectable="on" role="presentation"></span>
        </span>
    ) : null;

const Filter = () => (
    <span className="ag-header-icon ag-header-label-icon ag-filter-icon" aria-hidden="true">
        <span className="ag-icon ag-icon-filter" unselectable="on" role="presentation"></span>
    </span>
);

const Menu = ({ onClick }: { onClick: onClickMenu }) => {
    const menuRef = React.useRef<HTMLElement>(null);
    return (
        <span
            className="ag-header-icon ag-header-cell-menu-button"
            ref={menuRef}
            onClick={(e) => {
                e.stopPropagation();
                onClick(menuRef.current);
            }}
        >
            <span className="ag-icon ag-icon-menu" unselectable="on" role="presentation"></span>
        </span>
    );
};

type EditButtonProps = {
    onClick: () => void;
};

const EditButton = ({ onClick }: EditButtonProps) => {
    return (
        <div
            onClick={(e) => {
                e.stopPropagation();
                onClick();
            }}
            style={{ paddingLeft: "6px" }}
        >
            <Edit
                style={{
                    width: "12px",
                    height: "16px",
                    color: "var(--ag-secondary-foreground-color, rgba(0, 0, 0, 0.44))",
                }}
            />
        </div>
    );
};
